import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_PL.json';
import audios from './LOVE_AUDIOS_PL.json';

export const LOVE_DATA_PL: ServiceData = {
  articles,
  audios,
};
